module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/heat-map/heat-map.component.html
// module id = ../../../../../src/app/shared/components/graphs/heat-map/heat-map.component.html
// module chunks = main